import { Injectable } from "@angular/core";
import { Project } from "@models/project.model";
import BaseService from "./base.service";

/**
 * A variant of the BaseService where the Project's information is stored.
 *
 * @class ProjectService
 * @augments {BaseService<Project>}
 */
@Injectable({
  providedIn: "root",
})
export class ProjectService extends BaseService<Project> {
  getProjectById(id: string): Project | undefined {
    return this.getItems().find((p) => p.id == id);
  }

  getProjectsByDevelopmentId(id: number): Project[] {
    return this.getItems().filter((p) => p.developmentId == id);
  }
}
